import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_ADD,
	STR_AGENT_LOCATION,
	STR_AGENT_NAME,
	STR_AGENT_TYPE,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_EDIT_AGENT_PROFILE,
	STR_INVALID_AGENT_LOCATION,
	STR_INVALID_AGENT_NAME,
	STR_INVALID_AGENT_TILLS,
	STR_INVALID_AGENT_TYPE,
	STR_INVALID_TIN_NUMBER,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_STUDENTS,
	STR_NORMAL_AGENT,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SET_CURRENCY,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_SUPER_AGENT,
	STR_TILL_NAME,
	STR_TILL_NUMBER,
	STR_TILL_NUMBERS,
	STR_TILL_TYPE,
	STR_TIN_NUMBER,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP,
	STR_YOUR_PROFILE
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAdd, MdAnalytics, MdContactPage, MdDelete, MdDetails, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiProfileLine } from "react-icons/ri";
import NapaAddressPicker from "../ones/NapaAddressPicker";

export default function EditAgentProfile(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [agentName, setAgentName] = useState("");
	const [agentTin, setAgentTin] = useState("");
	const [agentType, setAgentType] = useState('normal_agent');
	const [agentLocation, setAgentLocation] = useState({});
	const [agentTills, setAgentTills] = useState([]);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	function addTillNumber() {
		setAgentTills((_prev) => {
			const _new = [..._prev];

			_new.push({
				tillType: '',
				tillNumber: '',
				tillName: agentName,
			});

			return _new;
		})
	}

	function handleTillNumberChange(index, field, value) {
		setAgentTills((_prev) => {
			const _new = [..._prev];

			_new[index][field] = value;

			return _new;
		})
	}

	function deleteTillNumber(index) {
		setAgentTills((_prev) => {
			const _new = [..._prev];

			_new.splice(index, 1);

			return _new;
		})
	}

	function checkTillNumbersValidity() {
		let isValid = true;

		for (const _till of agentTills) {
			if(
				(!_till.tillNumber || _till.tillNumber.trim().length === 0) ||
				(!_till.tillType || _till.tillType.trim().length === 0) ||
				(!_till.tillName || _till.tillName.trim().length === 0)
			) {
				isValid = false;
			}
		}

		return isValid;
	}

	async function submit() {
		if(agentName && agentName.trim().length > 0) {
			if(agentTin && agentTin.trim().length === 9) {
				if(agentType && agentType.trim().length > 0) {
					if(agentLocation && agentLocation.region && agentLocation.district && agentLocation.ward && agentLocation.street) {
						if(agentTills && agentTills.length > 0 && checkTillNumbersValidity()) {
							setLoading(true);
							await callApi(
								'edit-agent-profile',
								{
									agentName,
									agentTin,
									agentType,
									agentLocation: JSON.stringify(agentLocation),
									agentTills: JSON.stringify(agentTills),
								}
							).then(response => {
								if(response.status === 1) {
									appContext.tellMessage(STR_SUCCESS[appContext.language]);
									appContext.getCurrentUserData();
									//check current page
									if(
										appContext.navItem === 'view' &&
										appContext.navItem === 'edit-agent-profile'
									) {
										//go back
										appContext.navBack();
									} else {
										appContext.refresh();
									}
								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError(STR_INVALID_AGENT_TILLS[appContext.language])
						}
					} else {
						appContext.tellError(STR_INVALID_AGENT_LOCATION[appContext.language])
					}
				} else {
					appContext.tellError(STR_INVALID_AGENT_TYPE[appContext.language])
				}
			} else {
				appContext.tellError(STR_INVALID_TIN_NUMBER[appContext.language])
			}
		} else {
			appContext.tellError(STR_INVALID_AGENT_NAME[appContext.language])
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		if(appContext.currentUserData) {
			setAgentName(appContext.currentUserData.agentName);
			setAgentTin(appContext.currentUserData.agentTin);
			setAgentType(appContext.currentUserData.agentType);
			setAgentTills(JSON.parse(appContext.currentUserData.agentTills));
			setAgentLocation(JSON.parse(appContext.currentUserData.agentLocation));
		}
	}, [ appContext.currentUserData ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="col-md-12">
						<h6
							className="mSectionTitle"
						>
							{STR_EDIT_AGENT_PROFILE[appContext.language]}
						</h6>
					</div>

					<div className="col-md-12">
						<div className="mt-4 mb-4">
							<label className="form-label">{STR_AGENT_NAME[appContext.language]}</label>
							<input
								className="form-control"
								value={agentName}
								onChange={(e) => setAgentName(e.target.value)}
							/>
						</div>

						<div className="mt-4 mb-4">
							<label className="form-label">{STR_TIN_NUMBER[appContext.language]}</label>
							<input
								className="form-control"
								value={agentTin}
								onChange={(e) => setAgentTin(e.target.value)}
							/>
						</div>

						<div className="mt-4 mb-4">
							<label className="form-label">{STR_AGENT_TYPE[appContext.language]}</label>
							<select
								className="form-control"
								value={agentType}
								onChange={(e) => setAgentType(e.target.value)}
							>
								<option value="super_agent" >{STR_SUPER_AGENT[appContext.language]}</option>
								<option value="normal_agent" >{STR_NORMAL_AGENT[appContext.language]}</option>
							</select>
						</div>

						<div className="mt-4 mb-4">
							<label className="form-label">{STR_AGENT_LOCATION[appContext.language]}</label>
							<NapaAddressPicker callback={setAgentLocation}/>
						</div>

						<div className="mt-4 mb-4">
							<label className="form-label">{STR_TILL_NUMBERS[appContext.language]}</label>
							<div className="card">
								<div className="card-body">
									{
										agentTills.map((item, i) => {
											return (
												<div
													className="mShadow1"
													style={{
														padding: "10px",
														marginBottom: "10px"
													}}
													key={i}
												>
													<div className="row">
														<div className="col-6">
															<label className="form-label" style={{ fontSize: "12px" }}>{STR_TILL_NUMBER[appContext.language]}</label>
															<input
																value={item.tillNumber}
																className="form-control"
																onChange={(e) => handleTillNumberChange(i, 'tillNumber', e.target.value)}
															/>
														</div>

														<div className="col-6">
															<label className="form-label" style={{ fontSize: "12px" }}>{STR_TILL_TYPE[appContext.language]}</label>
															<select
																value={item.tillType}
																className="form-control"
																onChange={(e) => handleTillNumberChange(i, 'tillType', e.target.value)}
															>
																<option value=""></option>
																{
																	JSON.parse(appContext.systemParams.supportedTillTypes).map((item, i) => {
																		return (
																			<option key={i} value={item.id}>{item.name}</option>
																		)
																	})
																}
															</select>
														</div>

														<div className="col-12">
															<label className="form-label" style={{ fontSize: "12px" }}>{STR_TILL_NAME[appContext.language]}</label>
															<input
																value={item.tillName}
																className="form-control"
																onChange={(e) => handleTillNumberChange(i, 'tillName', e.target.value)}
															/>
														</div>

													</div>

													<div className="text-end mt-2">
														<MdDelete 
															className="text-danger"
															size={24}
															onClick={() => deleteTillNumber(i)}
														/>
													</div>
												</div>
											)
										})
									}

									<div className="">
										<hr/>
										<button
											className="btn btn-dark btn-sm"
											onClick={addTillNumber}
										>
											<MdAdd size={16}/> {STR_ADD[appContext.language]}
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className="mt-4 mb-4">
							<button
								className="btn btn-block btn-padded btn-rounded btn-primary"
								onClick={submit}
							>
								{STR_SUBMIT[appContext.language]}
							</button>
						</div>
					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}